import { SearchState } from 'src/hooks/meilisearch/types/search-state';

export const employeesGroupsKeys = {
  all: ['employees-groups'] as const,
  lists: () => [...employeesGroupsKeys.all, 'list'] as const,
  list: (
    directoryToken: string,
    page: number,
    perPage: number,
    searchState?: SearchState,
  ) =>
    [
      ...employeesGroupsKeys.lists(),
      directoryToken,
      { page, perPage, ...searchState },
    ] as const,
  infiniteList: (perPage: number) =>
    [...employeesGroupsKeys.lists(), 'infinite', { perPage }] as const,
  details: () => [...employeesGroupsKeys.all, 'detail'] as const,
  detail: (token: string) => [...employeesGroupsKeys.details(), token] as const,
};
